<template>
    <div class="header-width">
        <h1 style="padding:20px 0;">教材订购</h1>
        <div class="content">
            <a-tabs v-model="activeKey">
                <a-tab-pane key="1" tab="订购列表" style="display: flex;">
                    <list-left ref="ListLeft" style="width:60%;"></list-left>
                    <list-right @getListRight="getListRight" style="width:40%; border-left:1px dashed #cccccc;padding-right:10px;" @ChangeTab="ChangeTab"></list-right>
                </a-tab-pane>

                <a-tab-pane key="2" tab="订单信息">
                    <order-message :dataSource="dataSource" @ChangeTab="ChangeTab" :liveSpinning="liveSpinning"></order-message>
                </a-tab-pane>
            </a-tabs>
        </div>
    </div>
 
</template>

<script>
import ListLeft from './ListLeft.vue'
import ListRight from './ListRight.vue'
import OrderMessage from './OrderMessage.vue'
export default {
    name:'textbookOrderPage',
    components:{
        ListLeft,
        ListRight,
        OrderMessage
    },

    data:function(){
        return{
            activeKey:'1',
            dataSource:[],
            liveSpinning:true
        }
    },

    methods:{
        //调用listRight中的方法
        getListRight(){
            this.$refs.ListLeft.getOrderList()
        },

        ChangeTab(){
            // console.log(this.$refs.Tabs,'sha')
            this.activeKey = '2'

            this.axios.get(`/biz/material/order/mine`).then(res => {
                if (res.success) {
                    this.dataSource = res.result
                    this.liveSpinning = false
                }
            })
        }
    }
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';

.header-width{
    background: #f6f6f8;
    width: $pageWidth;
    margin: 0 auto;
        
    h1{
        font-size: 16px;
        font-weight: bold;
        
    }

    .content{
     background:#fff;
     padding:10px;
    }
}

</style>


// WEBPACK FOOTER //
// src/pages/textbookOrder/textOrder.vue